import { Avatar } from 'antd';
import styles from './custom-profile-avatar.module.css';
import { getInitials } from '../../utils/format-text/fomat-text';


export function CustomProfileAvatar({
  image,
  imageSrc,
  imageName,
  avatarSize = 'large',
  avatarShape = 'circle',
  divBackgroundColor = 'var(--primary-color)',
  divHeightWidth = 40,
  divFontSize = 18,
}) {
  return (
    <div>
      {image ? (
        <Avatar
          src={imageSrc}
          alt={imageName}
          size={avatarSize}
          shape={avatarShape}
          style={{ backgroundColor: '#fff' }}
        />
      ) : (
        <div
          style={{
            width: divHeightWidth,
            height: divHeightWidth,
            borderRadius: '50%',
            backgroundColor: divBackgroundColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: divFontSize,
            fontWeight: 'bold',
          }}
        >
          {imageName ? getInitials(imageName) : '-'}
        </div>
      )}
    </div>
  );
}

export default CustomProfileAvatar;
